import { PaymentStatus } from '../../../constants';
import { formatInMerchantTimezone, getMerchantTimezone } from '../../../utils/timezone';

export const COMPLETED_DATE_PLACEHOLDER = '---';

/**
 * Label for the completed-date column in the transactions list.
 * Only completed transactions display a date, always from completedDate.
 */
export const getCompletedDateLabel = (
  status: PaymentStatus | null | undefined,
  completedDate: string | null | undefined,
  timezone: string = getMerchantTimezone()
): string => {
  if (status !== PaymentStatus.COMPLETED) {
    return COMPLETED_DATE_PLACEHOLDER;
  }

  return formatInMerchantTimezone(completedDate, 'DD/MM/YY', timezone) || COMPLETED_DATE_PLACEHOLDER;
};
